// extracted by mini-css-extract-plugin
module.exports = {"metadataContainer":"executionDetail_metadataContainer__ZKbn9","inputOutputContainer":"executionDetail_inputOutputContainer__1sK0J"};